var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCallIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 17,
    viewBox: "0 0 13 13",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.1375 5.74375C4.0375 7.5125 5.4875 8.95625 7.25625 9.8625L8.63125 8.4875C8.8 8.31875 9.05 8.2625 9.26875 8.3375C9.96875 8.56875 10.725 8.69375 11.5 8.69375C11.8438 8.69375 12.125 8.975 12.125 9.31875V11.5C12.125 11.8438 11.8438 12.125 11.5 12.125C5.63125 12.125 0.875 7.36875 0.875 1.5C0.875 1.15625 1.15625 0.875 1.5 0.875H3.6875C4.03125 0.875 4.3125 1.15625 4.3125 1.5C4.3125 2.28125 4.4375 3.03125 4.66875 3.73125C4.7375 3.95 4.6875 4.19375 4.5125 4.36875L3.1375 5.74375Z",
    fill: "#0A2B45"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallIcon);
export default __webpack_public_path__ + "static/media/callIcon.cdab703ae369f7a4bb6db8a8c0c6090a.svg";
export { ForwardRef as ReactComponent };